import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api } from "../../../utlis/admin/api.utlis";
import Loader from "../../../layouts/loader/Loader";
import ApiService from "../../../core/services/ApiService";
import { decode, encode } from "base-64";
import moment from "moment";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { routes } from "../../../utlis/admin/routes.utlis";
import { status } from "../../../utlis/common.utlis";
import { Modal, ModalBody } from "react-bootstrap";
import toast from "react-hot-toast";

const JobDetails = () => {
  const navigate = useNavigate();
  const [stat, setStat] = useState({ status: false, value: null, name: null });
  const [job, setJob] = useState();
  const [loading, setLoading] = useState(false);
  const localData = useLocation();
  const id = localData.state?.id;

  const getJobDetails = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setJob(response.data.data);
    } else setJob();
    setLoading(false);
  };

  const changeStatus = async (status) => {
    setLoading(true);
    const form = JSON.stringify({
      status: parseInt(status),
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.postedChangeStatus + `${decode(id)}`,
      form
    );
    setStat({ status: false, value: null });
    if (response.data.status && response.data.statusCode === 200) {
      getJobDetails(api.postedJobDetail + `${decode(id)}`);
      toast.success(response.data.message);
    } else toast.error(response.data.message);
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getJobDetails(api.postedJobDetail + `${decode(id)}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="page-title">
            <Link
              className="btn-back"
              to=""
              onClick={(e) => {
                e.preventDefault();
                navigate(-1);
              }}
            >
              <i className="mdi mdi-arrow-left-thin"></i>
            </Link>
            Posted Job Detail
          </h3>
        </div>
        <div className="row">
          <div className="col-lg-12 mt-3">
            <div className="iq-card">
              <div className="iq-card-header d-flex justify-content-between">
                <div className="iq-header-title">
                  <h4 className="card-title">Job ID : {job?.job_id ?? "NA"}</h4>
                </div>
                <div>
                  {job?.status == 0 ? (
                    <div>
                      <button
                        className="btn-gr me-2"
                        onClick={(e) =>
                          setStat({ status: true, value: 1, name: "Approve" })
                        }
                      >
                        Approve
                      </button>
                      <button
                        className="btn-re"
                        onClick={(e) =>
                          setStat({ status: true, value: 3, name: "Reject" })
                        }
                      >
                        Reject
                      </button>
                    </div>
                  ) : (
                    <div className="select userselect">
                      <select
                        name="format"
                        id="format"
                        className="green-select"
                        onChange={(e) =>
                          setStat({
                            status: true,
                            value: e.target.value,
                            name: status(e.target.value),
                          })
                        }
                      >
                        <option
                          selected={job?.status == 1 ? true : false}
                          value="1"
                        >
                          Active
                        </option>
                        <option
                          selected={job?.status == 2 ? true : false}
                          value="2"
                        >
                          Inactive
                        </option>
                      </select>
                    </div>
                  )}
                </div>
              </div>

              <div className="iq-card-body">
                <div className="row ">
                  <div className="col-md-12">
                    <div className="card-body align-items-center d-flex">
                      <div className="d-flex justify-content-between w-100">
                        <div className="care-for-profile-img me-3 d-flex align-items-center">
                          {job?.provider?.image === null ||
                          job?.provider?.image === "" ||
                          job?.provider?.image === undefined ? (
                            <img
                              src={NoImage}
                              alt=""
                              className="me-2"
                              height={40}
                              width={40}
                              style={{
                                objectFit: "cover",
                                objectPosition: "center",
                              }}
                            />
                          ) : (
                            <img
                              src={job?.provider?.image}
                              alt=""
                              className="me-2"
                              height={40}
                              width={40}
                              style={{
                                objectFit: "cover",
                                objectPosition: "center",
                              }}
                            />
                          )}
                          <div className="">
                            <h5 className="">
                              {job?.provider?.fullname ?? "NA"}
                            </h5>
                            <p className="m-0">
                              Posted on :{" "}
                              {moment(job?.posted_date).format(
                                "MM-DD-yyyy hh:mm A"
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div>
                            <button
                              type="button"
                              className="btn-gr"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.providerDetails, {
                                  state: {
                                    id: encode(job?.care_provider_id),
                                  },
                                });
                              }}
                            >
                              View Profile
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12 ">
            <div className="iq-card">
              <div className="iq-card-header d-flex justify-content-between">
                <div className="iq-header-title">
                  <h4 className="card-title">{job?.title ?? "NA"}</h4>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn-bl"
                    style={{ cursor: "default" }}
                  >
                    ({job?.applicantListCount ?? 0}) Applicant Applied for this
                    Job
                  </button>
                </div>
              </div>

              <div className="iq-card-body">
                <div className="new-user-info">
                  <form>
                    <div className="row">
                      <div className="form-group col-md-4 mb-0">
                        <label>Job ID</label>
                        <p>{job?.job_id ?? "NA"}</p>
                      </div>
                      <div className="form-group col-md-4 mb-0">
                        <label>Posted Date</label>
                        <p>{moment(job?.posted_date).format("MM-DD-yyyy")}</p>
                      </div>

                      <div className="form-group col-md-4 mb-0">
                        <label>Posted Time</label>
                        <p>{moment(job?.posted_date).format("hh:mm A")}</p>
                      </div>
                      <div className="form-group col-md-4 mb-0">
                        <label for="add1">Work Experience</label>
                        <p>{job?.working_expirence ?? "NA"} Years</p>
                      </div>
                      <div className="form-group col-md-4 mb-0">
                        <label for="add1">Salary</label>
                        <p>
                          {job?.currency ?? "$"}
                          {job?.pay_range ?? "0"}/{job?.pay_range_type ?? ""}
                        </p>
                      </div>
                      <div className="form-group col-md-4 mb-0">
                        <label for="add1">Work Timing</label>
                        <p>{job?.working_time_value ?? "NA"}</p>
                      </div>
                      <div className="form-group col-md-4 mb-0">
                        <label for="add1">Category</label>
                        <p>{job?.category ?? "NA"}</p>
                      </div>
                      <div className="form-group col-md-4 mb-0">
                        <label for="add1">Sub Category</label>
                        <p>{job?.subcategory ?? "NA"}</p>
                      </div>
                      <div className="form-group col-md-12 mt-2 mb-0">
                        <label>Employee Benifits</label>
                        <p>{job?.employee_benifits ?? "NA"}</p>
                      </div>
                      <div className="form-group col-md-12 mt-2 mb-0">
                        <label>Qualification Requirement</label>
                        <p>{job?.qulification_required ?? "NA"}</p>
                      </div>
                      <div className="form-group col-md-12 mt-2 mb-0">
                        <label>Job Description</label>
                        <p>{job?.description ?? "NA"}</p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={stat.status}
        onHide={() => {
          setStat({
            status: false,
            value: null,
            name: null,
          });
        }}
        className=""
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0 mt-2">Change Status</h5>
                <p className="text-center">
                  Are you sure you want to{" "}
                  <span className="text-lowercase">{stat.name}</span> this
                  posted job ?
                </p>
              </div>
              <div className="form-group text-center">
                <button
                  type="button"
                  onClick={() =>
                    setStat({
                      status: false,
                      value: null,
                      name: null,
                    })
                  }
                  className="btn btn-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-gr me-2"
                  data-bs-dismiss="modal"
                  onClick={() => changeStatus(stat.value)}
                >
                  Yes! {stat.name}
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default JobDetails;
